import { FORGOT_PASSWORD, FORGOT_PASSWORD_ERROR } from "../types";

const initialState = {
  forgotPasswordInfo: {},
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FORGOT_PASSWORD:
      return {
        ...state,
        forgotPasswordInfo: action.payload,
        loading: false,
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
